import React from 'react';
import useOffline from '../../hooks/useOffline';

const OfflineBanner = ({ 
  message = "Vous êtes actuellement hors-ligne. Certaines fonctionnalités peuvent être limitées.",
  className = "fixed bottom-0 left-0 right-0 bg-red-600 text-white p-4 text-center z-50"
}) => {
  const isOffline = useOffline();

  if (!isOffline) return null;

  return (
    <div className={className}>
      <p className="text-sm font-medium">
        {message}
      </p>
    </div>
  );
};

export default OfflineBanner; 